import { fetchRequest } from "@common/helpers/util/requestMiddleware";
import { casinoMiddlewareURL } from "./constants";

class CasinoMiddlewareAuth {
  static #credientals = null;
  static onUnauthorize = () => {};

  static set credientals(data) {
    CasinoMiddlewareAuth.#credientals = data;
  }

  static get authData() {
    try {
      const authData = sessionStorage.getItem('casinoMiddlewareAuthData');
      return authData ? JSON.parse(authData) : null;
    } catch {
      return null;
    }
  }

  static set authData(data) {
    if (!data) window.sessionStorage.removeItem('casinoMiddlewareAuthData');
    else window.sessionStorage.setItem('casinoMiddlewareAuthData', JSON.stringify(data));
  }

  static get isAuthorized() {
    return !!CasinoMiddlewareAuth.authData;
  }

  static authorize = async () => {
    const result = await fetchRequest(
      casinoMiddlewareURL,
      'api/auth/authenticate',
      'POST',
      { body: this.#credientals },
    );

    if (result.Success) {
      CasinoMiddlewareAuth.authData = result.Data;
    }
  }
}

export default CasinoMiddlewareAuth;
